import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDebounce } from '../../hooks/useDebounce';

export const useAutoFocus = () => {
  const inputRef = useRef();
  const { state } = useLocation();

  useEffect(() => {
    // Get state from location and to set focus for search input if it is needed
    state && state.autofocus && inputRef.current.focus();
  }, [state]);

  return inputRef;
};

export const useSearchQuery = (query = '') => {
  const [searchValue, setSearchValue] = useState(query);
  const searchQuery = useDebounce(searchValue);

  useEffect(() => {
    setSearchValue(query);
  }, [query]);

  return {
    searchValue,
    searchQuery,
    setSearchValue,
  };
};
